import React, { useMemo, useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { Button } from "reactstrap"

import TableContainer from "../../../components/Common/DataTableContainer"
import { getAwardsCategoryList } from "../../../redux/actions/awards"

const AwardCategoryList = () => {
  document.title = "Award Category List | Admin Dashboard"

  const history = useNavigate()
  const dispatch = useDispatch()
  const { enc_award_id } = useParams()

  const awardCategoryList = useSelector(state => state.awards.awardCategoryList)
  const [categoryList, setCategoryList] = useState([])

  useEffect(() => {
    if (enc_award_id) {
      dispatch(getAwardsCategoryList({ enc_award_id }))
    }
  }, [enc_award_id])

  useEffect(() => {
    if (Array.isArray(awardCategoryList)) {
      setCategoryList(awardCategoryList)
    }
  }, [awardCategoryList])

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => info.row.index + 1,
      },
      {
        header: "Category Name",
        accessorKey: "category",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <button
              className="btn btn-sm btn-primary"
              onClick={() =>
                history("/awards/edit-award-category", {
                  state: {
                    enc_awd_cat_id: row.enc_awd_cat_id,
                    category: row.category,
                    enc_award_id,
                  },
                })
              }
              title="Edit Category"
            >
              Edit
            </button>
          )
        },
      },
    ],
    [history, enc_award_id]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
          <h4 className="h4 nom-title mb-0">Award Categories</h4>
          <div className="d-flex gap-2">
            <Button
              color="primary"
              onClick={() =>
                history("/awards/add-award-category", {
                  state: { enc_award_id },
                })
              }
            >
              Add Category
            </Button>
            <Button color="secondary" onClick={() => history(-1)}>
              Back
            </Button>
          </div>
        </div>

        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={categoryList}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search categories..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
    </div>
  )
}

export default AwardCategoryList
